import ApplicationComponent from "legacy/ApplicationComponent"
import Export from "legacy/reports/Export"
import PropTypes from "prop-types"
import React from "react"

class AccrualAccountingExport extends ApplicationComponent {
  constructor(props) {
    super(props)
    this.renderAdditionalDescription =
      this.renderAdditionalDescription.bind(this)
  }

  renderAdditionalDescription() {
    return (
      <div>
        For any date range, the report includes:
        <ul>
          <li>All line items posted</li>
          <li>All line items with recognized or unearned revenue</li>
          <li>
            All Dockwa-processed transactions, by date funds are <i>received</i>
          </li>
          <li>All offline transactions (cash, check, etc), by date recorded</li>
        </ul>
      </div>
    )
  }

  render() {
    return (
      <Export
        additionalDescription={this.renderAdditionalDescription()}
        {...this.props}
      />
    )
  }
}

AccrualAccountingExport.propTypes = {
  url: PropTypes.string.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  endDateRangeCutoff: PropTypes.string,
  amplitudeEvent: PropTypes.string,
  description: PropTypes.node,
  intercomHref: PropTypes.string,
  intercomCopy: PropTypes.string,
  multiPropertyEligible: PropTypes.bool,
}

export default AccrualAccountingExport
